export enum EXPLORA_ROUTES {
  Home = '/home',
  Productions = '/productions',
  Us = '/us',
  Blog = '/blog',
  Contact = '/contact',
  BlogManager = '/blog-editor'
}
